export default {
	name: "add-or-update-customer-group-pricing-for-zone-ex-tank",
	props:{
		productId:{
			default: null
		},
		companyId:{
			default: null
		}
	},
	data() {
		return {
			customerGroupPricingDelivery: {
				productId:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				customerId:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				selectedProduct: null,
				zoneErrorMessage: null,
				zonePricing:[],
				effectiveDate:{
					value: new Date(),
					hasError: false,
					errorMessage: null
				}
			},
			customerId: null,
			clearZonePricingTable: false,
			pricingUpdated: false,
			zones: [],
			products: [],
			companies: [],
			loading: false,
			isUpdate: false,
			resetPassword: false,
			errorModal:{
				modalHeading: "Error",
				elementId: "productPricingDeliveryModalError",
				modalMessage: "",
				showModal: false
			},
			successModal:{
				modalHeading: "Success",
				elementId: "productPricingDeliveryModalSuccess",
				modalMessage: "",
				showModal: false
			},
			initialiseDate: true,
			orderTypeId: null
		};
	},
	methods: {
		getCustomerGroupPricingDelivery(){
			this.loading = true;
			let request = {
				productId: this.productId,
				companyId: this.companyId,
				isActive: true,
				orderTypeId: orderHelper.orderType.exTank
			}

			this.customerId = this.companyId;
			productService.getCompanyShippingAddressPrices(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						this.customerGroupPricingDelivery.zonePricing = successResponse.data.result;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
			//self.customerGroupPricingDelivery.effectiveDate.value = "2023-06-20T13:35:21.58";

			//this.getZones();
		},
		getCompanies(){
			let request = {
				isActive: true,
				pageNumber: 1,
				pageSize: 5000,
				isCollectionCompany: false,
				isDeliveryCompany: false,
				isExTankCompany: true,
			};
			customerService.getCompanies(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess) {
						this.companies = successResponse.data.result;
						this.companies = $.map(this.companies,
							function (obj) {
								obj.id = obj.id || obj.companyId;
								obj.text = obj.text || obj.registeredCompanyName;
								return obj;
							});
						// if(this.customerId !== null){
						// 	this.customerGroupPricingDelivery.customerId.value = this.customerId;
						// }
						this.customerGroupPricingDelivery.customerId.value = this.companyId;
						console.log("customerGroupPricingDelivery.customerId", this.customerGroupPricingDelivery.customerId.value);
						console.log("companies", this.companies);
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getProducts(){
			let request = {
				isActive: true,
				allowExTank: true
			};
			productService.getProducts(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						this.products = successResponse.data.result;
						this.products = dataTableHelper.castFieldValues(this.products);
						this.products = $.map(this.products,
							function (obj) {
								obj.id = obj.id || obj.productId;
								obj.text = obj.text || obj.name;
								return obj;
							});
						this.customerGroupPricingDelivery.productId.value = this.productId;
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getZones(){
			let request = {
				isActive: true
			};
			let fieldsToFilterBy = [
				{
					value: null,
					key: "description"
				},
				// {
				// 	value: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
				// 	key: "isActive"
				// }
			];
			let activeOnly = true;
			systemService.getZones(fieldsToFilterBy, request, false, activeOnly).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.zones = successResponse.data.result;
						this.zones = dataTableHelper.castFieldValues(this.zones);
						for(let i = 0; i < this.zones.length; i++){
							this.zones[i].selected = false;
							this.zones[i].price = null;
							for(let j = 0; j < this.customerGroupPricingDelivery.zonePricing.length; j++){
								if(this.customerGroupPricingDelivery.zonePricing[j].zoneId === this.zones[i].zoneId){
									this.zones[i].price = this.customerGroupPricingDelivery.zonePricing[j].basePrice;
									break;
								}
							}
						}
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onProductSelect(product){
			console.log("product selected");
			this.clearZonePricingTable = false;
			if(this.customerGroupPricingDelivery.productId.value !== product.id){
				this.customerGroupPricingDelivery.productId.value = product.id;
			}
			this.customerGroupPricingDelivery.selectedProduct = this.getSelectedProduct(product.id);
		},
		onCompanySelect(company){
			this.clearZonePricingTable = false;
			if(this.customerGroupPricingDelivery.customerId.value !== company.id){
				this.customerGroupPricingDelivery.customerId.value = company.id;
			}
		},
		onZoneSelected(zone){
			this.clearZonePricingTable = false;
			this.customerGroupPricingDelivery.zonePricing = zone;
			this.pricingUpdated = true;
			console.log("zonePricing", this.customerGroupPricingDelivery.zonePricing);
		},
		onEffectiveDateSelect(date){
			this.clearZonePricingTable = false;
			this.customerGroupPricingDelivery.effectiveDate.value = date;
			this.initialiseDate = false;
		},
		getSelectedProduct(productId){
			for(let i = 0; i < this.products.length; i++){
				if(this.products[i].productId === productId){
					return this.products[i];
				}
			}
		},
		onBackClick(){
			this.$router.go(-1);
		},
		successModalOkClicked(){
			this.successModal = {
				modalHeading: "Success",
				elementId: "productPricingDeliveryModalSuccess",
				modalMessage: "",
				showModal: false
			};
			this.clearModel();
			if(this.isUpdate){
				this.$router.go(-1);
			}
		},
		errorModalOkClicked(){
			this.errorModal = {
				modalHeading: "Error",
				elementId: "productPricingDeliveryModalError",
				modalMessage: "",
				showModal: false
			};
		},
		saveDeliveryPricing(){
			this.loading = true;
			var productCustomerShippingAddressPrices = [];
			if(this.pricingUpdated){
				for(var i = 0; i < this.customerGroupPricingDelivery.zonePricing.length; i++){
					var productCustomerShippingAddressPrice = {
						companyShippingAddressPriceId: this.customerGroupPricingDelivery.zonePricing[i].customerZonePricingId,
						companyAddressId: this.customerGroupPricingDelivery.zonePricing[i].companyAddressId,
						discountAmount: this.customerGroupPricingDelivery.zonePricing[i].discountAmount,
						isActive: this.customerGroupPricingDelivery.zonePricing[i].isActive
					};
					productCustomerShippingAddressPrices.push(productCustomerShippingAddressPrice);
				}
			}

			let request = {
				productId: this.customerGroupPricingDelivery.productId.value === null ? 0 : this.customerGroupPricingDelivery.productId.value,
				companyId: this.customerGroupPricingDelivery.customerId.value === null ? 0 : this.customerGroupPricingDelivery.customerId.value,
				productCustomerShippingAddressPrices: productCustomerShippingAddressPrices,
				effectiveDate: this.customerGroupPricingDelivery.effectiveDate.value,
				orderTypeId: orderHelper.orderType.exTank
			};
			productService.addOrUpdateCompanyShippingAddressPrice(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.customerShippingAddressPriceValidationResponse.valuesAreValid){
							this.successModal.showModal = true;
							this.successModal.modalMessage = "Pricing Saved Successfully";
						}
						else{

							this.customerGroupPricingDelivery.productId.errorMessage = successResponse.data.customerShippingAddressPriceValidationResponse.productValidationResponse.message;
							this.customerGroupPricingDelivery.productId.hasError = successResponse.data.customerShippingAddressPriceValidationResponse.productValidationResponse.hasError;

							this.customerGroupPricingDelivery.customerId.errorMessage = successResponse.data.customerShippingAddressPriceValidationResponse.companyValidationResponse.message;
							this.customerGroupPricingDelivery.customerId.hasError = successResponse.data.customerShippingAddressPriceValidationResponse.companyValidationResponse.hasError;

							this.customerGroupPricingDelivery.effectiveDate.errorMessage = successResponse.data.customerShippingAddressPriceValidationResponse.effectiveDateValidationResponse.message;
							this.customerGroupPricingDelivery.effectiveDate.hasError = successResponse.data.customerShippingAddressPriceValidationResponse.effectiveDateValidationResponse.hasError;

							this.customerGroupPricingDelivery.zoneErrorMessage = successResponse.data.customerShippingAddressPriceValidationResponse.zonePricingValidationResponse.message;
						}
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		clearModel(){
			this.clearZonePricingTable = true;
			this.customerGroupPricingDelivery = {
				productId:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				customerId:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				selectedProduct: null,
				zoneErrorMessage: null,
				zonePricing:[],
				effectiveDate:{
					value: new Date(),
					hasError: false,
					errorMessage: null
				}
			};
			this.customerId = null;
			this.pricingUpdated = false;
			// for(let i = 0; i < this.zones.length; i++){
			// 	this.zones[i].selected = false;
			// 	this.zones[i].price = null;
			// }
		},
		setBreadcrumbs() {
			var pageTitle = "Add Customer Group Pricing For Zone";
			if((this.productId !== null && this.companyId !== null) && (this.productId > 0 && this.companyId > 0)){
				pageTitle = "Edit Customer Group Pricing For Zone";
			}
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		this.orderTypeId = orderHelper.orderType.exTank;
		this.setBreadcrumbs();
		this.getProducts();
		this.getCompanies();
	},
	watch: {
		productId: {
			handler: function () {
				if ((this.productId !== null && this.productId > 0) && (this.companyId !== null && this.companyId > 0)) {
					this.isUpdate = true;
					this.getCustomerGroupPricingDelivery();
				}
				else{
					this.isUpdate = false;
					//this.getZones();
				}
			},
			immediate: true,
			deep: true
		}
	}
};